export default __webpack_public_path__ + "static/media/151-pruners.9ab548d5.png";